import { render, staticRenderFns } from "./SPUAutoOffShelfDrawer.vue?vue&type=template&id=ac75a5d2&scoped=true"
import script from "./SPUAutoOffShelfDrawer.vue?vue&type=script&lang=ts"
export * from "./SPUAutoOffShelfDrawer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac75a5d2",
  null
  
)

export default component.exports